import { cn } from "@omni/utils/styles";

export const ProductComparisonSkeleton = () => {
    return (
        <div>
            <div className={cn("tw:flex tw:pl-80 tw:overflow-hidden")}>
                <div className={cn("tw:w-80 tw:min-w-80 tw:h-80 tw:mx-4")}>
                    <div className={cn("tw:w-full tw:h-80 tw:bg-grey")} />
                </div>
                <div className={cn("tw:w-80 tw:min-w-80 tw:h-80 tw:mx-4")}>
                    <div className={cn("tw:w-full tw:h-80 tw:bg-grey")} />
                </div>
                <div className={cn("tw:w-80 tw:min-w-80 tw:h-80 tw:mx-4")}>
                    <div className={cn("tw:w-full tw:h-80 tw:bg-grey")} />
                </div>
                <div className={cn("tw:w-80 tw:min-w-80 tw:h-80 tw:mx-4")}>
                    <div className={cn("tw:w-full tw:h-80 tw:bg-grey")} />
                </div>
                <div className={cn("tw:w-80 tw:min-w-80 tw:h-80 tw:mx-4")}>
                    <div className={cn("tw:w-full tw:h-80 tw:bg-grey")} />
                </div>
                <div className={cn("tw:w-80 tw:min-w-80 tw:h-80 tw:mx-4")}>
                    <div className={cn("tw:w-full tw:h-80 tw:bg-grey")} />
                </div>
                <div className={cn("tw:w-80 tw:min-w-80 tw:h-80 tw:mx-4")}>
                    <div className={cn("tw:w-full tw:h-80 tw:bg-grey")} />
                </div>
                <div className={cn("tw:w-80 tw:min-w-80 tw:h-80 tw:mx-4")}>
                    <div className={cn("tw:w-full tw:h-80 tw:bg-grey")} />
                </div>
            </div>
            <div
                className={cn(
                    "tw:w-full tw:bg-grey tw:mt-4 tw:relative tw:h-75"
                )}
            >
                <div
                    className={cn(
                        "tw:absolute tw:top-0 tw:left-0 tw:w-80 tw:bg-grey-light tw:h-full"
                    )}
                />
            </div>
            <div
                className={cn(
                    "tw:w-full tw:bg-grey tw:mt-4 tw:relative tw:h-25"
                )}
            >
                <div
                    className={cn(
                        "tw:absolute tw:top-0 tw:left-0 tw:w-80 tw:bg-grey-light tw:h-full"
                    )}
                />
            </div>
            <div
                className={cn(
                    "tw:w-full tw:bg-grey tw:mt-4 tw:relative tw:h-50"
                )}
            >
                <div
                    className={cn(
                        "tw:absolute tw:top-0 tw:left-0 tw:w-80 tw:bg-grey-light tw:h-full"
                    )}
                />
            </div>
            <div
                className={cn(
                    "tw:w-full tw:bg-grey tw:mt-4 tw:relative tw:h-75"
                )}
            >
                <div
                    className={cn(
                        "tw:absolute tw:top-0 tw:left-0 tw:w-80 tw:bg-grey-light tw:h-full"
                    )}
                />
            </div>
            <div
                className={cn(
                    "tw:w-full tw:bg-grey tw:mt-4 tw:relative tw:h-50"
                )}
            >
                <div
                    className={cn(
                        "tw:absolute tw:top-0 tw:left-0 tw:w-80 tw:bg-grey-light tw:h-full"
                    )}
                />
            </div>
        </div>
    );
};
